import React, { Component } from 'react';
import {connect} from 'react-redux';

import Config from '../service/ServiceColumnConfig.js';

class ServiceTableHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderHeaderText(text, width) {
    return (
      <div
        key={text}
        style={{ display: 'flex', marginLeft: 10, marginRight: 10, width: width, flexShrink: 0}}>
        <span
          style={{ fontSize: 12, color: '#4d6f7f'}}>
          {text}
        </span>
      </div>
    )
  }

  render() {
    const views = [];

    const viewHeaders = this.props.headers.slice();
    viewHeaders.unshift('index') //index should always be first
    viewHeaders.forEach(header => {
      let label = header;
      let columnWidth = 100;
      if (Config.modules[header]){
        label = Config.modules[header]['label'];
        columnWidth = Config.modules[header]['columnWidth'];
      }
      views.push(this.renderHeaderText(label, columnWidth));
    })

    return (
      <div
        key='header'
        style={{ display: 'flex', flexDirection: 'row', flexShrink: 0,
          height: 32, paddingLeft: 16, paddingRight: 16, paddingBottom: 8,
          boxShadow: 'inset 0 -2px 0 0 #c3deeb' }}>

        {views}
      </div>
    )
  }
}

function mapStateToProps(state){
  const args = state.reports.headers['SERVICE_HEADERS'];
  if (args && args.columnHeaders){
    return { headers: args.columnHeaders };
  } else {
    return { headers: [] };
  }
}


export default connect(mapStateToProps)(ServiceTableHeader);



// WEBPACK FOOTER //
// ./src/reports/service/ServiceTableHeader.js